import { render, staticRenderFns } from "./FrameworkChip.vue?vue&type=template&id=0747927b"
import script from "./FrameworkChip.vue?vue&type=script&lang=js"
export * from "./FrameworkChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports